import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  CUSTOMER_ORGANIZATION_LIST: 'organization-customer-organization',
  CUSTOMER_ORGANIZATION_INACTIVE_LIST: 'organization-customer-organization-inactive',
  CUSTOMER_ORGANIZATION_CREATE: 'organization-customer-organization-create',
  CUSTOMER_ORGANIZATION_DETAIL: 'organization-customer-organization-detail',
  CUSTOMER_ORGANIZATION_DOCUMENTS: 'organization-customer-organization-documents',
  CUSTOMER_ORGANIZATION_CONTACT_DETAIL: 'organization-customer-organization-contact-detail',
  CUSTOMER_ORGANIZATION_CONTACT_DOCUMENTS: 'organization-customer-organization-contact-documents',
  CUSTOMER_ORGANIZATION_AGREEMENTS: 'organization-customer-organization-agreements',
  CUSTOMER_ORGANIZATION_INSPECTIONS_LIST: 'organization-customer-inspections',
  CUSTOMER_ORGANIZATION_SECURITY_ROLES_LIST: 'organization-customer-security-role',
  CUSTOMER_ORGANIZATION_TASK: 'organization-customer-organization-task'
}

const listChildren = [
  {
    path: 'create/',
    name: ROUTES.CUSTOMER_ORGANIZATION_CREATE,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['organization_customerorganization_create'],
      requiresAuth: true
    },
    component: () => import('./CustomerOrganizationCreate.vue')
  },
  {
    path: ':id/',
    name: ROUTES.CUSTOMER_ORGANIZATION_DETAIL,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['organization_customerorganization_retrieve'],
      requiresAuth: true
    },
    component: () => import('./CustomerOrganizationDetail.vue')
  },
  {
    path: ':id/inspections',
    name: ROUTES.CUSTOMER_ORGANIZATION_INSPECTIONS_LIST,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['organization_organizationinspection_list'],
      requiresAuth: true
    },
    component: () => import('../../organization-inspections/OrganizationInspectionsList')
  },
  {
    path: ':id/security',
    name: ROUTES.CUSTOMER_ORGANIZATION_SECURITY_ROLES_LIST,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['organization_contact_list'],
      requiresAuth: true
    },
    component: () => import('../../../organization-contact-security-role/OrganizationSecurityRoleList')
  },
  {
    path: ':id/contact/:cntId/',
    name: ROUTES.CUSTOMER_ORGANIZATION_CONTACT_DETAIL,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['organization_customercontact_retrieve'],
      requiresAuth: true
    },
    component: () => import('../../../contact/contact/customer-contact/CustomerContactDetail')
  }
]

const routes = [
  {
    path: 'customer-organization/:orgType',
    name: ROUTES.CUSTOMER_ORGANIZATION_LIST,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['organization_customerorganization_list'],
      requiresAuth: true
    },
    component: () => import('./CustomerOrganizationList.vue'),
    children: listChildren
  },
  {
    path: 'customer-organization/inactive',
    name: ROUTES.CUSTOMER_ORGANIZATION_INACTIVE_LIST,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['organization_customerorganization_list'],
      requiresAuth: true
    },
    component: () => import('./CustomerOrganizationList.vue'),
    children: listChildren
  },
  {
    path: 'customer-organization/:orgType/:orgId/documents',
    name: ROUTES.CUSTOMER_ORGANIZATION_DOCUMENTS,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['document_uploaddocument_list'],
      requiresAuth: true
    },
    component: () => import('../../../../document/organization-upload-document/OrganizationUploadDocumentPage')
  },
  {
    path: 'customer-organization/:orgType/:orgId/:cntId/documents',
    name: ROUTES.CUSTOMER_ORGANIZATION_CONTACT_DOCUMENTS,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['document_uploaddocument_list'],
      requiresAuth: true
    },
    component: () => import('../../../../document/upload-document/UploadDocumentsList.vue')
  },
  {
    path: 'customer-organization/:orgType/:orgId/agreement-document',
    name: ROUTES.CUSTOMER_ORGANIZATION_AGREEMENTS,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['agreement_agreementdocument_list'],
      requiresAuth: true
    },
    component: () => import('../../../../agreement/agreement-document/AgreementDocumentList.vue')
  },
  {
    path: 'customer-organization/:orgType/:orgId/task',
    name: ROUTES.CUSTOMER_ORGANIZATION_TASK,
    beforeEnter: beforeEnter,
    props: (route) => ({
      orgId: route.params.orgId,
      categoryTypeCode: 'customer',
      parentDetailRouteName: ROUTES.CUSTOMER_ORGANIZATION_DETAIL,
      parentDetailRouteParams: { id: route.params.orgId, orgType: route.params.orgType }
    }),
    meta: {
      permissions: ['tasks_task_list'],
      requiresAuth: true
    },
    component: () => import('@/pages/task/task/TaskHistoryList.vue')
  }

]

export { routes, ROUTES }
